import { green, orange } from '@ant-design/colors'
import { CampaignEmployee } from '@models/Campaign'
import { Card, Progress, Space, Typography } from 'antd'
import { CampaignEmployeeStatus } from './Status'

const { Title } = Typography

interface Props {
  campaignEmployee?: CampaignEmployee
  type?: 'full' | 'condensed'
  readonly?: boolean
}

export const CampaignEmployeeCard = ({
  campaignEmployee,
  type = 'full',
  readonly = false,
}: Props) => {
  if (!campaignEmployee) {
    return <></>
  }

  return (
    <Card className={type == 'full' ? 'animated-border' : undefined}>
      <Space
        size={20}
        className="w-full"
        orientation={type == 'full' ? 'vertical' : 'horizontal'}
        style={{
          alignItems: 'center',
          justifyContent: type == 'full' ? undefined : 'space-between',
        }}
      >
        <Space size={15} className="w-full">
          {type == 'condensed' && (
            <Progress
              type="dashboard"
              percent={30}
              size={35}
              strokeColor={orange[4]}
            />
          )}
          <Space
            vertical
            style={{ alignItems: type == 'full' ? 'center' : 'flex-start' }}
            className="w-full"
            size={type == 'full' ? undefined : 0}
          >
            <Title level={type == 'full' ? 4 : 5} className="m-0">
              {campaignEmployee.campaign.name}
            </Title>
            {type == 'full' && (
              <Progress
                type="dashboard"
                percent={campaignEmployee.employeeProgression.progression}
                size={80}
                strokeColor={
                  campaignEmployee.employeeProgression.progression == 100
                    ? green[4]
                    : orange[4]
                }
              />
            )}
          </Space>
        </Space>
        <CampaignEmployeeStatus
          role="employee"
          campaignEmployee={campaignEmployee}
          readonly={readonly}
        />
      </Space>
    </Card>
  )
}

export type CampaignEmployeeCardType = {
  EmployeeCard: typeof CampaignEmployeeCard
}
